import Vue from "vue";
import ActionModal from "../components/ActionModal";
import AddManyContacts from "../components/AddManyContacts";
import CopySubscribersButton from "../components/campaign/subscribers/CopySubscribersButton";
import ExportContacts from "../components/ExportContacts";
import CampaignSubscribersTable from "../components/tables/CampaignSubscribersTable";
import SubscribeAllContactsModal from "../components/contact/SubscribeAllContactsModal";
import dateFormatter from "../mixins/dateFormatter";

Vue.component('campaign-subscribers-view', {
    components: { ExportContacts, CampaignSubscribersTable, AddManyContacts, ActionModal, CopySubscribersButton, SubscribeAllContactsModal },
    mixins: [dateFormatter],
    data() {
        return {
            subscribeAllContactsModal: false,
            campaign: JSON.parse(this.vueCampaign),
            vueAppErrors: [],
            subscriberCount: 0,
            unsubscriberCount: 0,
            globalUnsubscriberCount: 0,
            statusFilter: '',
            clickToToggleMeta: { 'toggle': false, 'params': {} }
        }
    },
    methods: {
        handleClickToFilterSubscribers() {
            this.clickToToggleMeta.toggle = this.clickToToggleMeta.toggle === 'subscribed' ? false : 'subscribed';
            this.clickToToggleMeta.params = {status: 'subscribed'};
        },
        handleClickToFilterUnsubscribers() {
            this.clickToToggleMeta.toggle = this.clickToToggleMeta.toggle === 'unsubscribed' ? false : 'unsubscribed';
            this.clickToToggleMeta.params = {status: 'unsubscribed'};
        },
        handleClickToFilterGlobalUnsubscribers() {
            this.clickToToggleMeta.toggle = this.clickToToggleMeta.toggle === 'global_unsubscribed' ? false : 'global_unsubscribed';
            this.clickToToggleMeta.params = {global_unsubscribe: true};
        },
        getCampaignToken() {
            return btoa('campaign_id=' + this.campaign.id);
        },
        onSubscribe() {
            this.subscriberCount++;
        },
        onResubscribe() {
            this.unsubscriberCount--;
            this.subscriberCount++;
        },
        onUnsubscribe() {
            this.unsubscriberCount++;
            this.subscriberCount--;
        },
    },
    props: ['vueCampaign', 'vesselId', 'timezone'],
    mounted() {
        this.subscriberCount = this.campaign.counts.subscribers;
        this.unsubscriberCount = this.campaign.counts.unsubscribers;
        this.globalUnsubscriberCount = this.campaign.counts.global_unsubscribers;
    }
});
